<template>
  <div class="pa-1">
    <TestQuestionMetadata v-model="q" ref="meta" @type-change="() => $refs.multiLang.prepareOptions()" class="ma-1"/>
    <h2 class="pa-2">Metadata</h2>
    <template v-for="(item, i) in q.metadata">
      <PastQuestionsMetadata v-model="q.metadata[i]" :key="i" :class="{'mt-2': i > 0}">
        <div class="text-right mt-2">
          <v-btn outlined @click="q.metadata.splice(i, 1)" color="red">Remove</v-btn>
        </div>
      </PastQuestionsMetadata>
    </template>
    <div class="text-right pa-2">
      <v-btn outlined color="green" @click="addMetadata">ADD METADATA</v-btn>
    </div>
    <v-card class="ma-1">
      <MultiLanguageQuestionComponent ref="multiLang" v-model="q"/>
      <v-divider/>
      <div class="text-center pa-4">
        <v-btn
            large
            color="red"
            dark
            :loading="sending"
            :disabled="sending"
            @click="submit"
        >Submit
        </v-btn>
      </div>
    </v-card>
    <v-dialog v-model="questionGetting" persistent width="300">
      <v-card color="red" dark>
        <v-card-text>
          Please stand by
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="questionGettingError" persistent width="300">
      <v-card color="red" dark>
        <v-card-text class="text-xs-center">
          <h2>Unknown Error Occurred</h2>
          <v-btn class="ma-2" flat outline @click="getQuestion">Retry</v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import TestQuestionMetadata from "@/components/tests/TestQuestionMetadata";
import LangQuestionComponent from "@/components/LangQuestionComponent";
import MultiLanguageQuestionComponent from "@/components/MultiLanguageQuestionComponent";
import PastQuestionsMetadata from "@/components/metadata/PastQuestionMetadata";

export default {
  name: "createOrUpdate",
  components: {PastQuestionsMetadata, MultiLanguageQuestionComponent, LangQuestionComponent, TestQuestionMetadata},
  data() {
    return {
      currentLang: 'en',
      sending: false,
      langDialog: false,
      questionGetting: false,
      questionGettingError: false,
      q: {
        country: null,
        examGroup: null,
        subject: null,
        chapterGroup: null,
        chapter: null,
        difficulty: null,
        type: null,
        languages: ["en"],
        metadata: [],
        question: {
          en: this.getLangQuestionModel()
        }
      }
    }
  },
  methods: {
    addMetadata() {
      this.q.metadata.push({
        country: null,
        examGroup: null,
        exam: null,
        subject: null,
        chapterGroup: null,
        chapter: null,
        topic: null,
        difficulty: null,
        marks: 0,
        negMarks: 0.0,
        timeAllotted: 0,
        order: 0
      })
    },
    getLangQuestionModel() {
      return {
        comprehension: null,
        direction: null,
        content: null,
        options: [],
        correct_options: [],
        answer: null,
        explanation: null
      }
    },
    async submit() {
      this.sending = true
      try {
        const {data} = await this.$practiceHttp.post("/createOrUpdate", {...this.q})
        if (data['statusCode'] === 0) {
          if (this.$route.params.id === "create") {
            this.$set(this.q, "status", "review");
            for (let i in this.q.question) {
              this.$set(this.q.question, i, {
                ...this.getLangQuestionModel(),
                comprehension: this.q.question[i].comprehension,
                direction: this.q.question[i].direction
              });
            }
            this.$refs.multiLang.prepareOptions()
          }
          this.$message.success('Successful')
        } else {
          this.$message.error('Unknown Error')
        }
      } catch (e) {
        this.$message.error(e.response ? e.response.data['error']['message'] : e.toString())
      }
      this.sending = false
    },
    getQuestion() {
      if (this.$route.params.id === "create") return
      this.questionGetting = true;
      this.questionGettingError = false;
      this.$practiceHttp
          .get("/" + this.$route.params.id)
          .then((res) => {
            this.questionGetting = false;
            let json = res.data;
            if (json.statusCode === 0) {
              this.$message.success("Success!")
              this.$set(this, "q", json.data);
              this.$refs.meta.populating = true
              setTimeout(this.$refs["meta"].populate, 1000);
              this.$refs.multiLang.mathJaxRefresh()
            } else {
              this.questionGettingError = true;
            }
          })
          .catch((err) => {
            this.questionGetting = false;
            this.questionGettingError = true;
          });
    }
  },
  mounted() {
    this.getQuestion()
  },
  watch: {
    "$route.params.id": function (val) {
      if (val !== "create") {
        this.getQuestion();
      }
    }
  }
}
</script>

<style scoped>

</style>
